import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ComponentCatalogPage } from '@frontend/features/component-catalog/components/ComponentCatalogPage';
import { PROCEDURE_CATEGORIES } from '@frontend/features/component-catalog/types/procedure.types';

const componentCatalogSearchSchema = z.object({
  // Search filter
  search: z.string().optional(),

  // Category filter
  category: z.enum(PROCEDURE_CATEGORIES).optional(),

  // Facility filter
  onFacility: z
    .union([z.boolean(), z.string()])
    .transform((val) => {
      if (typeof val === 'string') {
        return val === 'true';
      }
      return val;
    })
    .optional(),

  // Pagination
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100000).default(20),

  // Sort state
  sortBy: z
    .enum(['title', 'id', 'cptCode', 'category', 'standardRate', 'createdAt'])
    .default('title'),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
});

export const Route = createFileRoute('/component-catalog/')({
  component: ComponentCatalogPage,
  validateSearch: componentCatalogSearchSchema,
});
